// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__iCSPg","container":"style_container__3CsfL","mainImg":"style_mainImg__PPdC9","percentageSuccess":"style_percentageSuccess__iRSFV"};